(function () {
  var path = window.location.pathname;
  var search = window.location.search || "";
  var fullPath = path + search;

  var redirects = {
    "/home": "/",
    "/accessories": "/collections/accessories",
    "/6-pull-behind-cultipacker": "/products/6-pull-behind-cultipacker",
    "/hunter-500": "/products/plotmaster-hunter-500",
    "/hunter-400": "/products/plotmaster-hunter-400",
    "/hunter-800": "/products/plotmaster-hunter-800",
    "/hunter-600": "/products/plotmaster-hunter-600",
    "/nwsg-kit": "/collections/accessories",
    "/plotmower": "/collections/plotmower",
    "/chisel-plow": "/products/plotmaster-chisel-plow-attachment",
    "/manuals": "/pages/manuals",
    "/hunter-models": "/collections/plotmaster",
    "/blog/post/incentives--financing": "/pages/financing",
    "/testimonials": "/pages/community",
    "/about-us": "/pages/about-us",
    "/products/plotmaster-hunter-600?pr_prod_strat=e5_desc&pr_rec_id=109eba597&pr_rec_pid=9954845786429&pr_ref_pid=9954845753661&pr_seq=uniform": "/products/plotmaster-hunter-600",
    "/html/400.html": "/products/plotmaster-hunter-400",
    "/jdspecs.pdf": "/pages/manuals",
    "/fp_1206.html": "/",
    "/blog/post/mahindraplotmaster-400-filming": "/blogs/field-notes",
    "/blog/post/november-only": "/blogs/field-notes",
    "/trail-hawg": "/collections/trail-hawg",
    "/blog/post/plotting-season-has-begun": "/blogs/field-notes",
    "/blog/post/thanks-stuart-ranch-outfitters--clay-forst-for-sharing-plotmaster-foodplots": "/blogs/field-notes",
    "/blog/post/congrats-steve-fair": "/blogs/field-notes",
    "/blog/post/special-june-2430": "/blogs/field-notes",
    "/wpm": "/",
    "/_service/downloadFile.ashx?fileid=23282677-04c9-4559-8259-90298d69eaa8": "/pages/manuals",
    "/blog/post/big-savings": "/blogs/field-notes",
    "/blog/post/a-few-of-plotmaster-partners": "/blogs/field-notes",
    "/300.html": "/products/plotmaster-hunter-400",
    "/400.html": "/products/plotmaster-hunter-400",
    "/blog/post/a-few-of-plotmaster-partners?lang": "/blogs/field-notes",
    "/blogs/news": "/blogs/field-notes",
    "/pages/parts-service": "/pages/contact",
    "/blog/post/customer-pix-out-of-ky": "/blogs/field-notes",
    "/blog/post/top-mistakes-to-avoid-when-using-atvutv-tillage-implements-1": "/blogs/field-notes",
    "/testimonials/1000": "/pages/community",
    "/blog/post/plotmaster-food-plot-1": "/blogs/field-notes",
    "/blog/post/customer-plot-pix-out-of-ia": "/blogs/field-notes",
    "/video-links": "/pages/education",
    "/blog/post/uv-country-powersports": "/blogs/field-notes",
    "/success.html": "/pages/community",
    "/blog/post/from-seed-to-table--how-food-plots-can-provide-for-your-family": "/blogs/field-notes",
    "/blog/post/end-of-the-year": "/blogs/field-notes",
    "/blogs/news/best-food-plot-equipment-for-small-acreage-plotmaster": "/blogs/field-notes/best-food-plot-equipment-for-small-acreage-plotmaster",
    "/feedback.html": "/pages/community",
    "/blog/post/how-atvutv-tillage-implements-boost-agricultural-productivity": "/blogs/field-notes",
    "/blog/post/thank-you-ruffolos-rut-n-strut-shack-out-of-wi-for-sharing-your-plotmaster-pictures-foodplots": "/blogs/field-notes",
    "/blog/post/plotmaster-welcomes-new-tx-dealer": "/blogs/field-notes",
    "/blog/post/hunter-800-sale-ending?stype=social": "/blogs/field-notes",
    "/blog/post/hunter-800-sale-ending?lang": "/blogs/field-notes",
    "/blog/post/if-you-are-in-the-ny-area-and-have-questions-on-our-plotmaster-products-contact-joe-at-jc-wildlife-productsjoe-ciepiela-is-an-authorized-plotmaster-de": "/blogs/field-notes",
    "/blog/post/hunter-800-sale-ending": "/blogs/field-notes",
    "/blog/post/applications-of-the-plotmaster": "/blogs/field-notes",
    "/blog/post/plotmasters-special": "/blogs/field-notes",
    "/blogs/news/how-to-plant-a-fall-food-plot-with-minimal-equipment-plotmaster": "/blogs/field-notes/how-to-plant-a-fall-food-plot-with-minimal-equipment-plotmaster",
    "/blogs/news/no-till-drills-vs-plotmaster-the-better-food-plot-solution": "/blogs/field-notes/no-till-drills-vs-plotmaster-the-better-food-plot-solution",
    "/blog/post/hunter-400": "/products/plotmaster-hunter-400"
  };

  var exact = redirects[fullPath] || redirects[path];

  if (exact && exact !== fullPath && exact !== path) {
    window.location.replace(exact);
    return;
  }

  if (path.indexOf("/blog/post/") === 0) {
    if (path === "/blog/post/hunter-400") {
      window.location.replace("/products/plotmaster-hunter-400");
      return;
    }

    window.location.replace("/blogs/field-notes");
    return;
  }
})();